import axios from 'axios';

const state = () => ({
  personalInfo: null,
  accessToken: null,
  refreshToken: null,
  isAuthenticated: false,
});

const getters = {};

const mutations = {
  SET_USER_INFO(state, personalInfo) {
    state.personalInfo = personalInfo;
  },
  SET_AUTH_TOKEN(state, { accessToken, refreshToken }) {
    state.accessToken = accessToken;
    state.refreshToken = refreshToken;
    state.isAuthenticated = true;
  },
  SET_TOKEN(state, token) {
    state.personalInfo.token = token;
  },
  LOGOUT(state) {
    state.personalInfo = null;
    state.accessToken = null;
    state.refreshToken = null;
    state.isAuthenticated = false;
  },
};

const actions = {
  register(_, { firstName, lastName, name, address, phone, email, password }) {
    console.log(firstName, lastName, name, address, phone, email);
    return new Promise((resolve, reject) => {
      axios
        .post('/Register/Member', {
          name: name,
          userpwd: password,
          eMail: email,
          pmsTel: phone,
          pmsPhone: phone,
        })
        .then((resp) => {
          axios.post('/User', {
            code: 'tw',
            id: resp.data.userid,
          });
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  login({ commit }, { email, password }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/auth/loginForMemberUseEmail', {
          email,
          password,
        })
        .then((resp) => {
          commit('SET_USER_INFO', resp.data.member);
          commit('SET_AUTH_TOKEN', {
            accessToken: resp.data.accessTokenStr,
            refreshToken: resp.data.refreshTokenStr,
          });
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
    },
  //
    ValidateToken({ commit }, { token }) {
        return new Promise((resolve, reject) => {
            axios
                .post('/AppAndroid/ValidateToken', {
                    token: token,
                })
                .then((resp) => {
                    console.log(resp.data);
                    resolve(resp.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
  changePassword({ state }, { oldPassword, newPassword }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/Member/UpdateMemberPwd', {
          userid: state.personalInfo.userid,
          userpwd: newPassword,
          userOldPwd: oldPassword,
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  editPersonalInfo({ commit, state }, { name, phone }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/Member/${encodeURIComponent(state.personalInfo.userid)}`, {
          name: name,
          pmsPhone: phone,
        })
        .then((resp) => {
          let personalInfo = state.personalInfo;
          personalInfo.name = name;
          personalInfo.pmsPhone = phone;
          commit('SET_USER_INFO', personalInfo);
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getLicense({ state }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/About')
        .then((resp) => {
          const aboutList = resp.data
            .filter((v) => v.key.startsWith('about.'))
            .reduce((pre, curr) => {
              pre[curr.id] = curr.key;
              return pre;
            }, {});

          let promises = [];
          let translations = {};

          Object.entries(aboutList).forEach(([key, value]) => {
            promises.push(axios.get(`/AboutTranslation/${key}/${state.lang}`));
          });

          Promise.all(promises).then((responses) => {
            responses.forEach((response) => {
              const data = response.data;
              translations[aboutList[data.aboutId]] = data.value;
            });
            resolve(translations);
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getPersonalInfo(_, userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/Member/${encodeURIComponent(userId)}`)
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  /*
   * ForgetPassword
   */
  sendValidationCode(_, email) {
    return new Promise((resolve, reject) => {
      axios
        .post('/ForgetPassword/SendValidationCode', `"${email}"`, {
          headers: {
            'Content-Type': 'application/json-patch+json',
          },
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  checkValidationCode({ commit }, code) {
    return new Promise((resolve, reject) => {
      axios
        .post('/ForgetPassword/CheckValidationCode', `"${code}"`, {
          headers: {
            'Content-Type': 'application/json-patch+json',
          },
        })
        .then((resp) => {
          commit('SET_USER_INFO', resp.data);
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  resetPassword({ commit }, { userid, userpwd }) {
    console.log(userid, userpwd);
    return new Promise((resolve, reject) => {
      axios
        .post('/ForgetPassword/UpdateMemberPwd', { userid, userpwd })
        .then((resp) => {
          commit('SET_USER_INFO', null);
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
